import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import usePostAxiosData from 'hooks/usePostAxiosData';
import toast from 'react-hot-toast';

import InputField from 'components/fields/InputField';
import { Alert, AlertIcon, AlertTitle, Badge, Button, Tooltip } from '@chakra-ui/react';
import Error from 'components/message/Error';
import useDataFetching from 'hooks/useDataFetching';
import { config } from 'variables/config';
import axios from 'axios';
import { useAuthUser } from 'react-auth-kit';
import dayjs from 'dayjs';
import {
  BsBan,
  BsDoorClosed,
  BsGit,
  BsPen,
  BsPencilSquare,
  BsPlusCircle,
  BsPlusCircleFill,
  BsXCircleFill,
} from 'react-icons/bs';
import { checkIsValidPermit } from 'utils';
import { getExpiredPermitDate } from 'utils';
import 'dayjs/locale/fr';
import { checkIsValidPermitDate } from 'utils';
import {
  AppBar,
  Chip,
  Dialog,
  DialogContent,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Skeleton,
  Slide,
  Toolbar,
  Typography,
  capitalize,
} from '@mui/material';
import { CloseModalButton } from 'components/Utils';
import MuiAsyncAutocomplete from 'components/MuiAsyncAutocomplete';
import MuiCollapse from 'components/MuiCollapse';
import MButton from 'components/Mbutton';
import { formatDate } from 'utils';
import AddContract from './AddContract';
import { getLastContract } from 'utils';
import { checkIsValidContrat } from 'utils';
import { checkIsValidContractDate } from 'utils';
import MuiAUtocomplete from 'components/MuiAutocomplete';
import MuiDatePicker from 'components/MuiDatePicker';
import MuiSelect from 'components/MuiSelect';
import MMenus from 'components/MMenus';
import { DeleteForeverSharp, RestorePageRounded } from '@mui/icons-material';
import { EMPLOYER_STATUS } from 'Constaints';
import PreloaderSpinner from 'components/PreloaderSpinner';
import { GoneIcon } from 'components/TableIcon';
import { formatDateTime } from 'utils';
import { EWORK_DEMANDE_STATUS } from 'Constaints';
import FormSkeleton from 'components/FormSkeleton';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AddEmployer = ({
  open,
  handleClose,
  handleCloseOnly,
  get,
  selectedEmployerP,
  fixedEnterprise,
}) => {
  if (!open) return null;
  const { t } = useTranslation('add_employer');
  const [contractWithEmp, setContractWithEmp] = useState(null);
  const [selectedEmployer, setSelectedEmployer] = useState(selectedEmployerP);
  const [loadEmp, errorEMp, employee, fetchDataEmp] = useDataFetching(
    selectedEmployerP?.id ? `${config.app.api_url}/employers/${selectedEmployerP?.id}` : null,
    false
  );

  const [loadingM, errorM, modifications, fetcModifs] = useDataFetching(
    selectedEmployerP?.id
      ? `${config.app.api_url}/employers/${selectedEmployerP?.id}/modifications`
      : null
  );

  const [loadingF, errorF, fusions, fetchFusion] = useDataFetching(
    selectedEmployerP?.id
      ? `${config.app.api_url}/employers/${selectedEmployerP?.id}/fusions`
      : null
  );

  const [contracts, setContracts] = useState([]);
  useEffect(() => {
    selectedEmployerP && fetchDataEmp();
  }, [selectedEmployerP]);

  useEffect(() => {
    employee && setSelectedEmployer(employee?.data);
  }, [employee]);

  var relativeTime = require('dayjs/plugin/relativeTime');
  dayjs.extend(relativeTime);

  const schema = yup.object().shape({
    fullName: yup.string().required(t('personalInfo.fullNameLabel') + ' ' + t('general.required')),
    contratNumber: yup.string(),
    salary: yup.string().default('0'),
    indTransport: yup.string().default('0'),
    indLogement: yup.string().default('0'),
    indResponsabilite: yup.string().default('0'),
    indRepresentation: yup.string().default('0'),
    primeExploitation: yup.string().default('0'),
    sursalaire: yup.string().default('0'),
    primeSalissure: yup.string().default('0'),
    indCaisse: yup.string().default('0'),
    bonus: yup.string().default('0'),
    nui: yup.string().default('0'),
    primePanier: yup.string().default('0'),
    billetAvion: yup.string().default('0'),
    autresPrimes: yup.string().default('0'),
    visaNumber: yup.string(),
    passportNumber: yup.string(),
    qualification: yup.string(),
    permitNumber: yup.string(),
    observation: yup.string(),
    residencePermitNumber: yup.string(),
  });

  const auth = useAuthUser();
  const [sexe, setSexe] = useState(null);
  const [contractDuration, setContractDuration] = useState(null);
  const [hasVisa, setHasVisa] = useState('Non');
  const [hasResidentPermit, sethasResidentPermit] = useState('Non');

  useEffect(() => {
    if (hasVisa === 'Non') {
      setValue('visaNumber', undefined);
      setVisaOptDate(null);
      setVisaType(null);
    }
  }, [hasVisa]);

  useEffect(() => {
    if (hasResidentPermit === 'Non') {
      setValue('residencePermitNumber', undefined);
      setresidencePermitExpDate(null);
      setResidentType(null);
    }
  }, [hasResidentPermit]);

  const [residencePermitExpDate, setresidencePermitExpDate] = useState(null);
  const [date, setDate] = useState(null);
  const [birthDat, setBirthDat] = useState(null);
  const [visaOptDate, setVisaOptDate] = useState(null);
  const [passportExpDate, setpassportExpDate] = useState(null);
  const [diplome, setDiplonme] = useState(null);
  const [occupation, setOccupation] = useState(null);
  const [enterprise, setEnterprise] = useState(null);
  const [nationality, setNationality] = useState(null);
  const [visaType, setVisaType] = useState(null);
  const [entryType, setEntryType] = useState(null);
  const [residentType, setResidentType] = useState(null);
  const [canEdit, setCanEdit] = useState(false);

  const handleReset = () => {
    reset();
    setresidencePermitExpDate(null);
    setDate(null);
    setBirthDat(null);
    setVisaOptDate(null);
    setpassportExpDate(null);
    setDiplonme(null);
    setOccupation(null);
    setEnterprise(null);
    setNationality(null);
    setContractDuration(null);
    setEntryType(null);
    setVisaType(null);
    setResidentType(null);
    setContractWithEmp(null);
    setHasVisa('Non');
    sethasResidentPermit('Non');
    setSexe(null);
  };

  const durations = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
  ];

  const [loadingD, errorD, diplomes, fetchDataD] = useDataFetching(
    `${config.app.api_url}/diplomes`
  );
  const [loadingN, errorN, nationalities, fetchDataN] = useDataFetching(
    `${config.app.api_url}/countries`
  );
  const [loadingC, errorC, categories, fetchDataC] = useDataFetching(
    `${config.app.api_url}/categories`
  );
  const [loadingE, errorE, enterprises, fetchDataE] = useDataFetching(
    `${config.app.api_url}/enterprises/labels`
  );
  const [loadingO, errorO, occupations, fetchDataO] = useDataFetching(
    `${config.app.api_url}/occupations/all`
  );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmitHandler = (data) => {
    handleSave(data);
  };

  const [loading, postAxiosData, errorMassage, successMessage, result] = usePostAxiosData(
    `employers`,
    'POST'
  );

  const handleSave = async (formData) => {
    const data = {
      ...formData,
      id: selectedEmployer?.id || null,
      creatorId: selectedEmployer?.id ? null : auth()?.user?.id,
      editorId: auth()?.user?.id,
      enterpriseId: fixedEnterprise?.id
        ? fixedEnterprise?.id
        : enterprise
          ? parseInt(enterprise)
          : null,
      sexe: sexe,
      nationality: nationality,
      contratDuration: parseInt(contractDuration),
      visaOptDate: visaOptDate ? dayjs(new Date(visaOptDate)).format('YYYY-MM-DD') : null,
      passportExpDate: passportExpDate
        ? dayjs(new Date(passportExpDate)).format('YYYY-MM-DD')
        : null,
      residencePermitExpDate: residencePermitExpDate
        ? dayjs(new Date(residencePermitExpDate)).format('YYYY-MM-DD')
        : null,
      permitDate: date ? dayjs(new Date(date)).format('YYYY-MM-DD') : null,
      birthDate: birthDat ? dayjs(new Date(birthDat)).format('YYYY-MM-DD') : null,
      visaType,
      residentType,
      entryType,
      hasResidentPermit: hasResidentPermit === t('visaInfo.hasVisaOptions.yes') ? 'true' : 'false',
      hasVisa: hasVisa === t('visaInfo.hasVisaOptions.yes') ? 'true' : 'false',
      diplomeId: parseInt(diplome),
      occupationId: parseInt(occupation),
      contract: contractWithEmp,
    };

    await postAxiosData(data);
  };

  useEffect(() => {
    if (successMessage?.status === 200 || successMessage?.status === 201) {
      get();
      handleReset();
      handleCloseInside();
      toast.success(
        `${
          successMessage?.message != null
            ? successMessage?.message
            : t('buttons.saveSuccess', {
                action: selectedEmployer ? t('buttons.saveChanges') : t('buttons.save'),
              })
        }`,
        {
          duration: 4000,
          className: 'bg-success text-white',
        }
      );
    }
  }, [successMessage]);

  useEffect(() => {
    setCanEdit(!loading);
  }, [loading]);

  useEffect(() => {
    if (selectedEmployer) {
      setContracts(selectedEmployer?.contracts);
      setCanEdit(false);
      setValue(
        'fullName',
        selectedEmployer?.fullName ||
          selectedEmployer?.firstName + ' ' + selectedEmployer?.lastName ||
          undefined
      );
      setValue('nui', selectedEmployer?.nui || undefined);
      setValue('contratNumber', selectedEmployer?.contratNumber || undefined);
      setValue('permitNumber', selectedEmployer?.permitNumber || undefined);
      setValue('salary', selectedEmployer?.salary || undefined);
      setValue('indTransport', selectedEmployer?.indTransport || undefined);
      setValue('indLogement', selectedEmployer?.indLogement || undefined);
      setValue('indResponsabilite', selectedEmployer?.indResponsabilite || undefined);
      setValue('indRepresentation', selectedEmployer?.indRepresentation || undefined);
      setValue('primeExploitation', selectedEmployer?.primeExploitation || undefined);
      setValue('sursalaire', selectedEmployer?.sursalaire || undefined);
      setValue('primeSalissure', selectedEmployer?.primeSalissure || undefined);
      setValue('indCaisse', selectedEmployer?.indCaisse || undefined);
      setValue('bonus', selectedEmployer?.bonus || undefined);
      setValue('primePanier', selectedEmployer?.primePanier || undefined);
      setValue('billetAvion', selectedEmployer?.billetAvion || undefined);
      setValue('autresPrimes', selectedEmployer?.autresPrimes || undefined);
      setValue('observation', selectedEmployer?.observation || undefined);
      setContractDuration(selectedEmployer?.contratDuration);
      setDate(selectedEmployer?.permitDate);
      setOccupation(selectedEmployer?.occupation?.id);
      setEnterprise(selectedEmployer?.enterprise?.id);
      setValue('visaNumber', selectedEmployer?.visaNumber || undefined);
      setValue('passportNumber', selectedEmployer?.passportNumber || undefined);
      setValue('qualification', selectedEmployer?.qualification || undefined);
      setValue('residencePermitNumber', selectedEmployer?.residencePermitNumber || undefined);
      setSexe(selectedEmployer?.sexe);
      setNationality(selectedEmployer?.nationality);
      setHasVisa(
        selectedEmployer?.visaOptDate?.length > 0 ||
          selectedEmployer?.visaNumber?.length > 0 ||
          selectedEmployer?.hasVisa == true
          ? t('visaInfo.hasVisaOptions.yes')
          : t('visaInfo.hasVisaOptions.no')
      );
      sethasResidentPermit(
        selectedEmployer?.residencePermitExpDate?.length > 0 ||
          selectedEmployer?.residencePermitNumber?.length > 0 ||
          selectedEmployer?.hasResidentPermit == true
          ? t('visaInfo.hasVisaOptions.yes')
          : t('visaInfo.hasVisaOptions.no')
      );
      setresidencePermitExpDate(selectedEmployer?.residencePermitExpDate);
      setBirthDat(selectedEmployer?.birthDate);
      setVisaOptDate(selectedEmployer?.visaOptDate);
      setpassportExpDate(selectedEmployer?.passportExpDate);
      setDiplonme(selectedEmployer?.diplome?.id);
      setVisaType(selectedEmployer?.residentType);
      setResidentType(selectedEmployer?.visaType);
      setEntryType(selectedEmployer?.entryType);
    } else {
      setCanEdit(true);
      handleReset();
    }
  }, [selectedEmployer]);

  const handleCloseInside = () => {
    if (handleCloseOnly) {
      handleCloseOnly();
    } else {
      setSelectedEmployer(null);
      setSetselectedContract(null);
      setContractWithEmp(null);
      setContracts([]);
      handleReset();
      handleClose();
      setCanEdit(true);
    }
  };

  const [openAddContract, setOpenAddContract] = useState(false);
  const [selectedContract, setSetselectedContract] = useState(null);
  const [loadingCh, postAxiosChange, errorMassageC, successMessageC, resultC] = usePostAxiosData(
    `employers/${selectedEmployer?.id}/change-status`,
    'PUT'
  );

  const changeStatus = (status) => {
    window.confirm(t(`alerts.${EMPLOYER_STATUS[status]?.alert}`)) &&
      postAxiosChange({ employeeStatus: status, userId: auth()?.user?.id });
  };

  useEffect(() => {
    if (successMessageC?.status === 200 || successMessageC?.status === 201) {
      handleCloseInside();
      get();
      toast.success(
        `${
          successMessageC?.message != null ? successMessageC?.message : t('buttons.statusUpdated')
        }`,
        {
          duration: 4000,
          className: 'bg-success text-white',
        }
      );
    }
  }, [successMessageC]);

  useEffect(() => {
    if (errorMassageC) {
      toast.error(
        `${
          errorMassageC?.message != null ? errorMassageC?.message : t('buttons.statusUpdateFailed')
        }`
      );
    }
  }, [errorMassageC]);

  const [lastContract, setLastContract] = useState(null);
  useEffect(() => {
    contracts && setLastContract(getLastContract(contracts));
  }, [contracts]);

  function Notif({ id }) {
    const [loadingM, errorM, modificationsC, fetcModifs] = useDataFetching(
      id ? `${config.app.api_url}/contracts/${id}/modifications` : null
    );

    return (
      modificationsC && (
        <MuiCollapse
          title={t('contractInfo.contractHistoryTitle', {
            count: modificationsC?.data?.length || 0,
          })}
          bgColor={'rgba(150,0,0,0.1)'}
        >
          <List>
            {modificationsC?.data
              ?.sort((a, b) => a?.editedAt < b?.editedAt)
              ?.map((m) => (
                <ListItem disablePadding divider>
                  <ListItemButton>
                    <ListItemText
                      primary={`${m?.editedBy?.firstName || ''} ${m?.editedBy?.lastName || ''} --${formatDateTime(m?.editedAt)}`}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
          </List>
        </MuiCollapse>
      )
    );
  }

  return (
    <>
      <div>
        {loadingCh && <PreloaderSpinner />}
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          onClose={handleCloseInside}
          aria-labelledby="customized-dialog-title"
          open={open}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar
              className={
                selectedEmployer?.status == EMPLOYER_STATUS.GONE.value
                  ? 'bg-yellow-200'
                  : selectedEmployer?.status == EMPLOYER_STATUS.DELETED.value
                    ? 'bg-red-300'
                    : 'bg-gray-50'
              }
            >
              <Typography color={'green'} sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {selectedEmployer
                  ? `${!canEdit ? t('buttons.viewEmployee') : t('buttons.editEmployee')} ${selectedEmployer?.fullName || selectedEmployer?.firstName + ' ' + selectedEmployer?.lastName}`
                  : t('buttons.addEmployee', {
                      enterprise: fixedEnterprise ? fixedEnterprise?.socialRaison : '',
                    })}
              </Typography>
              <div className="flex justify-end gap-2 pr-10">
                {selectedEmployer && (
                  <Tooltip
                    hasArrow
                    label={canEdit ? t('buttons.lockTooltip') : t('buttons.editTooltip')}
                    bg="red.200"
                    color="black"
                    placement="bottom"
                  >
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={() => setCanEdit(!canEdit)}
                      aria-label="edit or lock"
                    >
                      {canEdit ? (
                        <BsBan className="text-red-500" />
                      ) : (
                        <BsPencilSquare className="text-blue-500" />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
                {selectedEmployer && (
                  <MMenus
                    options={[
                      {
                        icon: <BsDoorClosed color="Warning" />,
                        label: t('buttons.employeeGone'),
                        handleClick: () => changeStatus('GONE'),
                      },
                      {
                        icon: <DeleteForeverSharp color="danger" />,
                        label: t('buttons.delete'),
                        handleClick: () => changeStatus('DELETED'),
                      },
                      selectedEmployer?.status != EMPLOYER_STATUS.CREATED.value && {
                        icon: <RestorePageRounded color="action" />,
                        label: t('buttons.restore'),
                        handleClick: () => changeStatus('CREATED'),
                      },
                    ].filter(Boolean)}
                  />
                )}
              </div>
              <CloseModalButton
                iconColor={'red'}
                handleClose={handleCloseInside}
                dataCy="close-employer-modal-button"
              />
            </Toolbar>
          </AppBar>
          {loadEmp ? (
            <FormSkeleton />
          ) : (
            <DialogContent dividers>
              {(selectedEmployer?.status == EMPLOYER_STATUS.GONE.value ||
                selectedEmployer?.status == EMPLOYER_STATUS.DELETED.value) && (
                <Alert
                  className="mb-5 rounded-lg shadow"
                  status={
                    EMPLOYER_STATUS.GONE.value == selectedEmployer?.status ? 'warning' : 'error'
                  }
                >
                  <GoneIcon />
                  <AlertTitle>
                    {EMPLOYER_STATUS.GONE.value == selectedEmployer?.status
                      ? t('alerts.employeeGone')
                      : t('alerts.employeeDeleted')}
                  </AlertTitle>
                </Alert>
              )}
              {selectedEmployer && lastContract && !checkIsValidContrat(lastContract) ? (
                <Alert
                  className="mb-5 rounded-lg shadow"
                  status={checkIsValidContractDate(lastContract) ? 'warning' : 'error'}
                >
                  <AlertIcon />
                  <AlertTitle>
                    {lastContract?.permitNumber ? '' : t('alerts.noPermitNumber')}
                    {t(
                      checkIsValidContractDate(lastContract)
                        ? 'alerts.permitExpiresOn'
                        : 'alerts.permitExpiredOn'
                    )}
                    :{' '}
                    {dayjs(getExpiredPermitDate(lastContract?.permitDate)).format('DD-MM-YYYY') ||
                      '--'}
                  </AlertTitle>
                  (
                  {lastContract?.permitDate
                    ? dayjs(getExpiredPermitDate(lastContract?.permitDate)).locale('fr').fromNow()
                    : '--'}
                  )
                </Alert>
              ) : selectedEmployer && !lastContract ? (
                <Alert className="mb-5 rounded-lg shadow" status="error">
                  <AlertIcon />
                  <AlertTitle>{t('alerts.noContract')}</AlertTitle>
                </Alert>
              ) : (
                selectedEmployer && (
                  <Alert className="mb-5 rounded-lg shadow" status="success">
                    <AlertIcon />
                    <AlertTitle>
                      {t('alerts.permitValidUntil')} :{' '}
                      {dayjs(getExpiredPermitDate(lastContract?.permitDate)).format('DD-MM-YYYY') ||
                        '--'}
                      ( Expire{' '}
                      {lastContract?.permitDate
                        ? dayjs(new Date())
                            .locale('fr')
                            .to(dayjs(getExpiredPermitDate(lastContract?.permitDate)).locale('fr'))
                        : '--'}
                      )
                    </AlertTitle>
                  </Alert>
                )
              )}
              <form onSubmit={handleSubmit(onSubmitHandler)}>
                {errorMassage?.message && <Error message={errorMassage?.message} />}
                <div>
                  <div>
                    <h2 className="font-bold text-green-500">{t('personalInfo.title')}</h2>
                    <hr />
                  </div>
                  <div className="my-4 grid gap-5 md:grid-cols-2">
                    <InputField
                      disabled={!canEdit}
                      register={register}
                      variant="auth"
                      extra="mb-3"
                      label={t('personalInfo.fullNameLabel')}
                      required={true}
                      id="fullName"
                      name="fullName"
                      type="text"
                      error={errors.fullName?.message}
                      dataCy="fullName-input"
                    />
                    <MuiSelect
                      disabled={!canEdit}
                      value={sexe}
                      label={t('personalInfo.selectSexLabel')}
                      options={[
                        { value: '', label: t('general.noneOption') },
                        { value: 'Masculin', label: t('personalInfo.sexOptions.male') },
                        { value: 'Feminin', label: t('personalInfo.sexOptions.female') },
                      ]}
                      onChange={(event) => setSexe(event.target.value)}
                      dataCy="select-sexe"
                    />
                    <MuiDatePicker
                      label={t('personalInfo.birthDateLabel')}
                      value={birthDat}
                      disabled={!canEdit}
                      fullWidth={true}
                      onChange={(newValue) => setBirthDat(new Date(newValue)?.getTime())}
                      wrapperClasses={'flex-1 filter-item anime w-full slideLeft'}
                      dataCy="birthDay-date"
                    />
                    <MuiSelect
                      disabled={!canEdit}
                      value={diplome}
                      label={t('personalInfo.selectDiplomaLabel')}
                      options={diplomes?.data}
                      onChange={(event) => setDiplonme(event.target.value)}
                      format={{ value: 'id', label: 'name' }}
                      emptyLabel={t('general.noneOption')}
                      dataCy="select-diplome"
                    />
                    <MuiAUtocomplete
                      disabled={!canEdit}
                      value={nationality}
                      defaultValue={nationality}
                      label={t('personalInfo.selectNationalityLabel')}
                      options={nationalities?.data?.map((item) => ({
                        value: item?.nameEn,
                        label: item?.nameFr || item?.nameEn,
                      }))}
                      onChange={(e, item) => setNationality(item?.value)}
                      wrapperClasses={'flex-1 filter-item anime slideRight'}
                      dataCy={'nationalite-autocomplete'}
                    />
                    <MuiSelect
                      disabled={!canEdit}
                      value={entryType}
                      label={t('personalInfo.entryTypeLabel')}
                      options={[
                        { value: '', label: t('general.noneOption') },
                        { value: '0', label: t('personalInfo.entryTypeOptions.visaShortStay') },
                        { value: '1', label: t('personalInfo.entryTypeOptions.visaLongStay') },
                        { value: '2', label: t('personalInfo.entryTypeOptions.residenceCard') },
                        { value: '3', label: t('personalInfo.entryTypeOptions.residentCard') },
                      ]}
                      onChange={(event) => setEntryType(event.target.value)}
                      emptyLabel={t('general.noneOption')}
                      dataCy="select-entryType"
                    />
                  </div>
                </div>
                <div>
                  <div>
                    <h2 className="font-bold text-green-500">{t('visaInfo.title')}</h2>
                    <hr />
                  </div>
                  <MuiSelect
                    disabled={!canEdit}
                    value={hasVisa}
                    label={t('visaInfo.hasVisaLabel')}
                    options={[
                      {
                        value: t('visaInfo.hasVisaOptions.yes'),
                        label: t('visaInfo.hasVisaOptions.yes'),
                      },
                      {
                        value: t('visaInfo.hasVisaOptions.no'),
                        label: t('visaInfo.hasVisaOptions.no'),
                      },
                    ]}
                    onChange={(event) => setHasVisa(event.target.value)}
                    emptyLabel={t('general.noneOption')}
                    dataCy="select-hasVisaOptions"
                  />
                  {hasVisa === t('visaInfo.hasVisaOptions.yes') && (
                    <div className="my-4 grid gap-2 md:grid-cols-2 anime slideUp">
                      <MuiSelect
                        disabled={!canEdit}
                        value={visaType}
                        label={t('visaInfo.visaTypeLabel')}
                        options={[
                          { value: '', label: t('general.noneOption') },
                          { value: '0', label: t('visaInfo.visaTypeOptions.shortStay') },
                          { value: '1', label: t('visaInfo.visaTypeOptions.longStay') },
                        ]}
                        onChange={(event) => setVisaType(event.target.value)}
                        emptyLabel={t('general.noneOption')}
                        dataCy="select-visaTypeOptions"
                      />
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('visaInfo.visaNumberLabel')}
                        id="visaNumber"
                        name="visaNumber"
                        type="text"
                        error={errors.visaNumber?.message}
                        dataCy="visaNumber-input"
                      />
                      <MuiDatePicker
                        label={t('visaInfo.visaObtainedDateLabel')}
                        value={visaOptDate}
                        disabled={!canEdit}
                        fullWidth={true}
                        onChange={(newValue) => setVisaOptDate(new Date(newValue)?.getTime())}
                        wrapperClasses={'flex-1 filter-item anime w-full slideLeft'}
                        dataCy="visaObtained-date"
                      />
                    </div>
                  )}
                </div>
                <div>
                  <div>
                    <h2 className="font-bold text-green-500">{t('residenceInfo.title')}</h2>
                    <hr />
                  </div>
                  <MuiSelect
                    disabled={!canEdit}
                    value={hasResidentPermit}
                    label={t('residenceInfo.hasResidencePermitLabel')}
                    options={[
                      {
                        value: t('visaInfo.hasVisaOptions.yes'),
                        label: t('visaInfo.hasVisaOptions.yes'),
                      },
                      {
                        value: t('visaInfo.hasVisaOptions.no'),
                        label: t('visaInfo.hasVisaOptions.no'),
                      },
                    ]}
                    onChange={(event) => sethasResidentPermit(event.target.value)}
                    emptyLabel={t('general.noneOption')}
                    dataCy="select-hasResidentPermit"
                  />
                  {hasResidentPermit === t('visaInfo.hasVisaOptions.yes') && (
                    <div className="my-4 grid gap-2 md:grid-cols-2 anime slideUp">
                      <MuiSelect
                        disabled={!canEdit}
                        value={residentType}
                        label={t('residenceInfo.residenceTypeLabel')}
                        options={[
                          { value: '', label: t('general.noneOption') },
                          { value: '0', label: t('residenceInfo.residenceTypeOptions.shortStay') },
                          { value: '1', label: t('residenceInfo.residenceTypeOptions.resident') },
                        ]}
                        onChange={(event) => setResidentType(event.target.value)}
                        emptyLabel={t('general.noneOption')}
                        dataCy="select-residentType"
                      />
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('residenceInfo.residencePermitNumberLabel')}
                        id="residencePermitNumber"
                        name="residencePermitNumber"
                        type="text"
                        error={errors.residencePermitNumber?.message}
                        dataCy="residencePermitNumber-input"
                      />
                      <MuiDatePicker
                        label={t('residenceInfo.residencePermitExpDateLabel')}
                        value={residencePermitExpDate}
                        disabled={!canEdit}
                        fullWidth={true}
                        onChange={(newValue) =>
                          setresidencePermitExpDate(new Date(newValue)?.getTime())
                        }
                        wrapperClasses={'flex-1 filter-item anime w-full slideLeft'}
                        dataCy="residencePermitExp-date"
                      />
                    </div>
                  )}
                </div>
                <div>
                  <h2 className="font-bold text-green-500">{t('passportInfo.title')}</h2>
                  <hr />
                  <div className="my-4 grid gap-2 md:grid-cols-2">
                    <InputField
                      disabled={!canEdit}
                      register={register}
                      variant="auth"
                      extra="mb-3"
                      label={t('passportInfo.passportNumberLabel')}
                      id="passportNumber"
                      name="passportNumber"
                      type="text"
                      error={errors.passportNumber?.message}
                      dataCy="passportNumber-input"
                    />
                    <MuiDatePicker
                      label={t('passportInfo.passportExpDateLabel')}
                      value={passportExpDate}
                      disabled={!canEdit}
                      fullWidth={true}
                      onChange={(newValue) => setpassportExpDate(new Date(newValue)?.getTime())}
                      wrapperClasses={'flex-1 filter-item anime w-full slideLeft'}
                      dataCy="passportExpDate-date"
                    />
                  </div>
                </div>
                <Paper className="p-3">
                  <h1 className="font-bold text-green-500 text-xl">
                    {t('contractInfo.title')}
                    <Badge
                      fontSize={15}
                      rounded={5}
                      padding={1}
                      paddingInline={2}
                      colorScheme="orange"
                      color={'black'}
                      marginLeft={2}
                    >
                      {contracts?.length}
                    </Badge>
                  </h1>
                  <hr />
                  {!fixedEnterprise && (
                    <MuiAUtocomplete
                      disabled={!canEdit}
                      value={enterprise}
                      label={t('general.enterpriseLabel')}
                      options={enterprises?.data}
                      format={{ value: 'id', label: 'socialRaison' }}
                      onChange={(e, item) => setEnterprise(item?.value)}
                      wrapperClasses={'flex-1 filter-item anime slideRight mb-3'}
                      dataCy={'enterprise-autocomplete'}
                    />
                  )}
                  {(enterprise == '' || enterprise == null || enterprise == undefined) && (
                    <div className="anime slideRight mb-3">
                      <InputField
                        disabled={!canEdit}
                        register={register}
                        variant="auth"
                        extra="mb-3"
                        label={t('general.niuLabel')}
                        id="nui"
                        name="nui"
                        type="text"
                        error={errors.nui?.message}
                        dataCy="nui-input"
                      />
                    </div>
                  )}
                  {(contracts || (contractWithEmp ? Array(contractWithEmp) : []))?.map(
                    (contract, index) => (
                      <MuiCollapse
                        title={`${contracts?.length - index}${t('contractInfo.contractOrdinal.' + (contracts?.length - index === 1 ? 'first' : 'other'))} - ${t('contractInfo.permitDateLabel')} : ${contract?.permitDate ? formatDate(getExpiredPermitDate(contract?.permitDate)) : '--'}`}
                        subTitle={
                          <div className="flex gap-4 justify-between">
                            {!checkIsValidContractDate(contract) ? (
                              <Chip
                                color="error"
                                className="capitalize-none"
                                label={t('contractInfo.status.expired')}
                              />
                            ) : contract?.permitNumber ? (
                              <Chip
                                className="capitalize-none"
                                variant="outlined"
                                color="success"
                                label={t('contractInfo.status.valid')}
                              />
                            ) : (
                              <Chip
                                className="capitalize-none"
                                variant="outlined"
                                color="warning"
                                label={t('contractInfo.status.toVerify')}
                              />
                            )}
                            <IconButton title={t('contractInfo.editContractTooltip')}>
                              <BsPencilSquare
                                color="blue"
                                onClick={(e) => {
                                  e?.preventDefault();
                                  e?.stopPropagation();
                                  setSetselectedContract(contract);
                                  setOpenAddContract(true);
                                }}
                              />
                            </IconButton>
                          </div>
                        }
                        index={index}
                      >
                        <div>
                          <div className="flex justify-between">
                            <h2 className="font-bold text-green-500">
                              {t('contractInfo.contractTitle')}
                            </h2>
                          </div>
                          <hr />
                          {contract && !checkIsValidContrat(contract) ? (
                            <Alert className="mb-5 rounded-lg shadow" status="error">
                              <AlertIcon />
                              <AlertTitle>
                                {contract?.permitNumber ? '' : t('alerts.noPermitNumber')}
                                {t(
                                  checkIsValidPermitDate(contract)
                                    ? 'alerts.permitExpiresOn'
                                    : 'alerts.permitExpiredOn'
                                )}
                                :{' '}
                                {dayjs(getExpiredPermitDate(contract?.permitDate)).format(
                                  'DD-MM-YYYY'
                                ) || '--'}
                              </AlertTitle>
                              (
                              {contract?.permitDate
                                ? dayjs(getExpiredPermitDate(contract?.permitDate))
                                    .locale('fr')
                                    .fromNow()
                                : '--'}
                              )
                            </Alert>
                          ) : (
                            contract && (
                              <Alert className="mb-5 rounded-lg shadow" status="success">
                                <AlertIcon />
                                <AlertTitle>
                                  {t('alerts.permitValidUntil')} :{' '}
                                  {dayjs(getExpiredPermitDate(contract?.permitDate)).format(
                                    'DD-MM-YYYY'
                                  ) || '--'}
                                  ( Expire{' '}
                                  {lastContract?.permitDate
                                    ? dayjs(new Date())
                                        .locale('fr')
                                        .to(
                                          dayjs(
                                            getExpiredPermitDate(lastContract?.permitDate)
                                          ).locale('fr')
                                        )
                                    : '--'}
                                  )
                                </AlertTitle>
                              </Alert>
                            )
                          )}
                          <div className="my-4 grid gap-2 md:grid-cols-2">
                            <MuiAUtocomplete
                              disabled={true}
                              value={contract?.occupation?.id || contract?.occupationId}
                              label={t('contractInfo.selectOccupationLabel')}
                              options={occupations?.data}
                              format={{ value: 'id', label: 'name' }}
                              wrapperClasses={'flex-1 filter-item anime slideRight'}
                            />
                            <InputField
                              disabled={true}
                              value={contract?.contratNumber}
                              variant="auth"
                              extra="mb-3"
                              label={t('contractInfo.contractNumberLabel')}
                              id="contratNumber"
                              name="contratNumber"
                              type="text"
                              error={errors.contratNumber?.message}
                            />
                            <InputField
                              disabled={true}
                              value={contract?.contratDuration}
                              variant="auth"
                              extra="mb-3"
                              label={t('contractInfo.contractDurationLabel')}
                              id="contratNumber"
                              name="contratNumber"
                              type="text"
                            />
                          </div>
                        </div>
                        <div>
                          <div>
                            <h2 className="font-bold text-green-500">{t('salaryInfo.title')}</h2>
                            <hr />
                          </div>
                          <div className="my-4 grid gap-2 md:grid-cols-6">
                            <InputField
                              disabled={true}
                              value={contract?.salary}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.baseSalaryLabel')}
                              defaultValue={'0'}
                              id="salary"
                              name="salary"
                              type="number"
                              error={errors.salary?.message}
                              min="0"
                            />
                            <InputField
                              min="0"
                              disabled={true}
                              value={contract?.indTransport}
                              variant="auth"
                              defaultValue={'0'}
                              extra="mb-3"
                              label={t('salaryInfo.transportAllowanceLabel')}
                              id="indTransport"
                              name="indTransport"
                              type="number"
                              error={errors.indTransport?.message}
                            />
                            <InputField
                              min="0"
                              disabled={true}
                              value={contract?.indLogement}
                              variant="auth"
                              defaultValue={'0'}
                              extra="mb-3"
                              label={t('salaryInfo.housingAllowanceLabel')}
                              id="indLogement"
                              name="indLogement"
                              type="number"
                              error={errors.indLogement?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.responsibilityBonusLabel')}
                              id="indResponsabilite"
                              name="indResponsabilite"
                              value={contract?.indResponsabilite}
                              type="number"
                              error={errors.indResponsabilite?.message}
                            />
                            <InputField
                              disabled={true}
                              variant="auth"
                              defaultValue={'0'}
                              extra="mb-3"
                              label={t('salaryInfo.representationBonusLabel')}
                              id="indRepresentation"
                              name="indRepresentation"
                              value={contract?.indRepresentation}
                              type="number"
                              error={errors.indRepresentation?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.expatriationBonusLabel')}
                              id="primeExploitation"
                              name="primeExploitation"
                              value={contract?.primeExploitation}
                              type="number"
                              error={errors.primeExploitation?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.overtimeSalaryLabel')}
                              id="sursalaire"
                              name="sursalaire"
                              value={contract?.sursalaire}
                              type="number"
                              error={errors.sursalaire?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.dirtBonusLabel')}
                              id="primeSalissure"
                              name="primeSalissure"
                              value={contract?.primeSalissure}
                              type="number"
                              error={errors.primeSalissure?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.cashAllowanceLabel')}
                              id="indCaisse"
                              name="indCaisse"
                              value={contract?.indCaisse}
                              type="number"
                              error={errors.indCaisse?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.bonusLabel')}
                              id="bonus"
                              name="bonus"
                              value={contract?.bonus}
                              type="number"
                              error={errors.bonus?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.basketBonusLabel')}
                              id="primePanier"
                              name="primePanier"
                              value={contract?.primePanier}
                              type="number"
                              error={errors.primePanier?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.flightTicketLabel')}
                              id="billetAvion"
                              name="billetAvion"
                              value={contract?.billetAvion}
                              type="number"
                              error={errors.billetAvion?.message}
                            />
                            <InputField
                              disabled={true}
                              defaultValue={'0'}
                              variant="auth"
                              extra="mb-3"
                              label={t('salaryInfo.otherBonusesLabel')}
                              id="autresPrimes"
                              name="autresPrimes"
                              value={contract?.autresPrimes}
                              type="number"
                              error={errors.autresPrimes?.message}
                            />
                          </div>
                          <div>
                            <div>
                              <h2 className="font-bold text-green-500">
                                {t('contractInfo.permitTitle')}
                              </h2>
                              <hr />
                            </div>
                            <div className="my-4 grid gap-2 md:grid-cols-2 anime slideUp">
                              <InputField
                                disabled={true}
                                variant="auth"
                                extra="mb-3"
                                label={t('contractInfo.permitNumberLabel')}
                                id="permitNumber"
                                name="permitNumber"
                                value={contract?.permitNumber}
                                type="text"
                                error={errors.permitNumber?.message}
                              />
                              <InputField
                                disabled={true}
                                value={contract?.permitDate ? formatDate(contract?.permitDate) : ''}
                                variant="auth"
                                extra="mb-3"
                                label={t('contractInfo.permitDateLabel')}
                                id="contratNumber"
                                name="contratNumber"
                                type="text"
                              />
                            </div>
                          </div>
                        </div>
                        {contract && (
                          <Badge>
                            {t('general.collectedBy', {
                              name: contract?.creator
                                ? `${contract?.creator?.firstName} ${contract?.creator?.lastName}`
                                : '--',
                            })}
                          </Badge>
                        )}
                        {contract && (
                          <Badge color={'black'} backgroundColor={'orange'}>
                            {contract ? formatDateTime(contract?.createdAt) : '--'}
                          </Badge>
                        )}
                        <Notif id={contract?.id} />
                      </MuiCollapse>
                    )
                  )}
                  {(selectedEmployer || !contractWithEmp) && (
                    <div className="flex justify-end my-2">
                      <MButton
                        disabled={!canEdit}
                        variant="white"
                        onClick={(e) => {
                          e?.preventDefault();
                          e?.stopPropagation();
                          setOpenAddContract(true);
                        }}
                      >
                        <BsPlusCircleFill size={20} /> {t('contractInfo.addContractButton')}
                      </MButton>
                    </div>
                  )}
                </Paper>
                {selectedEmployer && (
                  <Badge>
                    {t('general.collectedBy', {
                      name: selectedEmployer?.creator
                        ? `${selectedEmployer?.creator?.firstName} ${selectedEmployer?.creator?.lastName}`
                        : '--',
                    })}
                  </Badge>
                )}
                {selectedEmployer && (
                  <Badge color={'black'} backgroundColor={'orange'}>
                    {selectedEmployer ? formatDateTime(selectedEmployer?.createdAt) : '--'}
                  </Badge>
                )}
                {selectedEmployer && (
                  <MuiCollapse
                    title={
                      <span className="flex items-center">
                        <BsPen className="me-2" color="orange" />
                        {t('modifications.title', { count: modifications?.data?.length || 0 })}
                      </span>
                    }
                    bgColor={'rgba(150,0,0,0.1)'}
                  >
                    <List>
                      {modifications?.data?.length < 1 ? (
                        <ListItem disablePadding divider>
                          <ListItemButton>
                            <ListItemText primary={t('general.noModifications')} />
                          </ListItemButton>
                        </ListItem>
                      ) : (
                        modifications?.data
                          ?.sort((a, b) => a?.editedAt < b?.editedAt)
                          ?.map((m) => (
                            <ListItem disablePadding divider>
                              <ListItemButton>
                                <ListItemText
                                  primary={`${m?.editedBy?.firstName || ''} ${m?.editedBy?.lastName || ''} --${formatDateTime(m?.editedAt)}`}
                                  secondary={m?.description}
                                />
                              </ListItemButton>
                            </ListItem>
                          ))
                      )}
                    </List>
                  </MuiCollapse>
                )}
                {selectedEmployer && (
                  <MuiCollapse
                    title={
                      <span className="flex items-center">
                        <BsGit className="me-2" color="red" />
                        {t('modifications.fusionsTitle', { count: fusions?.data?.length || 0 })}
                      </span>
                    }
                    bgColor={'rgba(150,0,0,0.1)'}
                  >
                    <List>
                      {fusions?.data?.length < 1 ? (
                        <ListItem disablePadding divider>
                          <ListItemButton>
                            <ListItemText primary={t('general.noMerges')} />
                          </ListItemButton>
                        </ListItem>
                      ) : (
                        fusions?.data
                          ?.sort((a, b) => a?.mergedAt < b?.mergedAt)
                          ?.map((m) => (
                            <ListItem disablePadding divider>
                              <ListItemButton>
                                <ListItemText
                                  primary={`${m?.mergedBy?.firstName || ''} ${m?.mergedBy?.lastName || ''} --${formatDateTime(m?.mergedAt)}`}
                                  secondary={`${m?.mergedEmployee?.fullName} --> ${m?.mainEmployee?.fullName} | Reason: ${m?.description}`}
                                />
                              </ListItemButton>
                            </ListItem>
                          ))
                      )}
                    </List>
                  </MuiCollapse>
                )}
                <div className="mt-2">
                  <InputField
                    disabled={!canEdit}
                    multiline={true}
                    register={register}
                    variant="auth"
                    extra="mb-3"
                    label={t('general.observationsLabel')}
                    required={false}
                    id="observation"
                    name="observation"
                    type="text"
                    error={errors.observation?.message}
                    dataCy="observation-input"
                  />
                </div>
                <div className="flex justify-between p-4">
                  <div>
                    <MButton
                      variant={'danger'}
                      onClick={(e) => {
                        e?.stopPropagation();
                        e?.preventDefault();
                        handleCloseInside();
                      }}
                    >
                      {t('buttons.close')}
                    </MButton>
                  </div>
                  <div>
                    {((selectedEmployer && canEdit) ||
                      selectedEmployer == null ||
                      selectedEmployer == undefined) && (
                      <MButton type="submit" colorScheme="green" isLoading={loading}>
                        {selectedEmployer ? t('buttons.saveChanges') : t('buttons.save')}
                      </MButton>
                    )}
                  </div>
                </div>
              </form>
            </DialogContent>
          )}
        </Dialog>
      </div>
      <AddContract
        contract={contractWithEmp}
        setContract={setContractWithEmp}
        get={() => {
          fetchDataEmp();
          get();
        }}
        open={openAddContract}
        handleClose={() => {
          setSetselectedContract(null);
          setOpenAddContract(false);
        }}
        selectedEmployer={selectedEmployer}
        selectedContract={selectedContract}
      />
    </>
  );
};

export default AddEmployer;
